import { css } from '@emotion/react';

import { typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

export type EnrollButtonSize = 'small' | 'large';

const styles = {
  buttonWrapper: (theme: Theme, size?: EnrollButtonSize) => css`
    // Important styles are to override ApiButton.
    & > button,
    & > a {
      background: ${theme.palette.blue[600]} !important;
      box-shadow: inset 0 0 0 1px ${theme.palette.blue[600]};
      border-radius: 4px;
      width: 100%;
      ${typography2.bodyPrimary}
      color: var(--cds-color-white-0) !important;
      font-weight: 700;
      padding: ${theme.spacing(size === 'small' ? 8 : 12, 32)};
      ${size === 'small' &&
      `
        min-height: 36px;
        font-size: 0.875rem;
        line-height: 1.25rem;
      `}
      transition: none;

      &:hover {
        background: ${theme.palette.blue[700]} !important;
      }
    }

    & > button[disabled] {
      background: ${theme.palette.gray[400]} !important;
      box-shadow: none;
      border: none;

      &:hover {
        background: ${theme.palette.gray[400]} !important;
      }
    }

    .cui-iconWrapper {
      display: none;
    }

    .rc-StartDateButton {
      line-height: 1.2rem;

      > div {
        padding-top: 0;
        font-size: 0.8rem;
      }
    }
  `,
};

export default styles;
